import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-073eeaf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "word-num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "word-num__row" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "word-num__col" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              variant: "outlined",
              class: "word-num__col__card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "word-num__col__card__title" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Teacher Unique Word Counts ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "word-num__col__card__text" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getUniqueWordCount(_ctx.wordCount.teacher_word_count)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "word-num__col" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              variant: "outlined",
              class: "word-num__col__card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "word-num__col__card__title" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Student Unique Word Counts ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "word-num__col__card__text" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getUniqueWordCount(_ctx.wordCount.student_word_count)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}